import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { Button } from '../../root/components/common'
import { Box } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    modalButtons: {
        marginTop: 15
    },
    heading: {
        fontFamily: theme.typography.fontFamily,
        fontSize: 22,
        color: theme.quaternary,
        fontWeight: 500
    },
    textWrapper: {
        textAlign: 'center',
        width: 450
    },
    text: {
        fontFamily: theme.typography.fontFamily,
        fontSize: 17,
        color: theme.quaternary,
        fontWeight: 500
    }
}))

export const UsersAssignedRoleInfoModal = ({ setOpen }) => {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    return (
        <Box className={classes.wrapper}>
            <Box className={classes.heading} component="p">
                {locale.userManagement.usersStillAssigned}
            </Box>
            <Box className={classes.textWrapper}>
                <Box className={classes.text} component="p">
                    {locale.userManagement.usersAssignedTheRole}
                </Box>
                <Box className={classes.text} component="p">
                    {locale.userManagement.reassignThatUsers}
                </Box>
            </Box>

            <Box className={classes.modalButtons}>
                <Button onClick={() => setOpen(false)}>
                    {locale.common.close}
                </Button>
            </Box>
        </Box>
    )
}
